export const ExcelTemplateCodes = {
  ReportAppendix: 'ReportAppendix', // 报告附件模板
}